import { FartherManagedAccount } from "@fartherfinance/frontend/api/Accounts/Types";
import {
  FartherAccountId,
  InstitutionId,
} from "@fartherfinance/frontend/api/Types";

export const transferTypes = [
  "Deposit",
  "Withdrawal",
  "Investment",
  "IRA",
] as const;

export const IraTypes = [
  "IRA",
  "ROTH_IRA",
  "SIMPLE_IRA",
  "BENEFICIARY_ROTH_IRA",
] as const;
type IraType = typeof IraTypes[number];

export type CreateTransferDepositFormData = {
  transferType: {
    label: "Deposit";
    value: "Deposit";
  };
  withdrawalAccountLabel: string;
  depositAccount: {
    label: string;
    account: FartherManagedAccount;
  };
  depositAmount: string;
  depositContributionYear: {
    label: string;
  };
};

export type CreateTransferWithdrawalFormData = {
  transferType: {
    label: "Withdrawal";
    value: "Withdrawal";
  };
  depositAccountLabel: string;
  withdrawalAccount: {
    label: string;
    account: FartherManagedAccount;
  };
  withdrawalAmount: string;
};

export type CreateTransferInvestmentFormData = {
  transferType: {
    label: "Investment";
    value: "Investment";
  };
  accountType: {
    label: string;
    accountType: "INDIVIDUAL" | "JOINT" | "TRUST";
  };
  institution: {
    label: string;
    institutionId: InstitutionId;
  };
  accountNumber: string;
  accountHolderName: string;
  accountDestination: {
    label: string;
    accountType: string;
    balance: number | null;
    accountNumber: FartherAccountId;
    accountId: FartherAccountId;
  };
  requestSigned: boolean;
};

export type CreateTransferIRAFormData = {
  transferType: {
    label: "IRA";
    value: "IRA";
  };
  iraType: {
    label: string;
    iraType: IraType;
  };
  institution: {
    label: string;
    institutionId: InstitutionId;
  };
  accountNumber: string;
  accountHolderName: string;
  accountDestination: {
    label: string;
    accountType: string;
    balance: number | null;
    accountNumber: FartherAccountId;
    accountId: FartherAccountId;
  };
  requestSigned: boolean;
};

export type CreateTransferFormData =
  | CreateTransferDepositFormData
  | CreateTransferWithdrawalFormData
  | CreateTransferInvestmentFormData
  | CreateTransferIRAFormData;
